import { secretbox, randomBytes } from "utils/nacl";
import {
    decodeUTF8,
    encodeUTF8,
    encodeBase64,
    decodeBase64
} from "utils/nacl-utils";
import Cookies from "common/cookies";

import _ from "lodash";

const sharedKey = "1xaX2OAzQm+Y8YQsrQ0nFmO2KZyMgRDPnHwzZtV+smY=";

// export const invisibleCharacters = ["\u2060","\u2061","\u2062","\u2063","\u2064","\u206A","\u206B","\u206C","\u206D"];
export const invisibleCharacters = ["\u2061","\u2062","\u2063","\u2064","\u206A","\u206B","\u206C","\u206D"];

export function getRandomInvisibleCharacter() {
    let id = _.random(0, invisibleCharacters.length - 1);    
    return invisibleCharacters[id];
}

export function getModulusString(input) {
    let sessionId = Cookies.get("vertx-web.session");
    let modulus = getModulusFromString(sessionId, input.length);

    let firstPart = input.substring(0, modulus);
    let lastPart = input.substring(modulus, input.length);		
    let finalResult = firstPart + getRandomInvisibleCharacter() + lastPart;
    return finalResult;
}

export function encrypt(originalMessage) {
    let keyUint8Array = decodeBase64(sharedKey);
    let nonce = randomBytes(secretbox.nonceLength);
    let messageUint8 = decodeUTF8(originalMessage);
    let box = secretbox(messageUint8, nonce, keyUint8Array);
    let fullMessage = new Uint8Array(nonce.length + box.length);
    fullMessage.set(nonce);
    fullMessage.set(box, nonce.length);
    let base64FullMessage = encodeBase64(fullMessage);	
    return base64FullMessage;
}

export function decrypt(encryptedMessage) {
    let keyUint8Array = decodeBase64(sharedKey);
    const encryptedMessageAsUint8Array = decodeBase64(encryptedMessage);
    const nonce = encryptedMessageAsUint8Array.slice(0, secretbox.nonceLength);
    const message = encryptedMessageAsUint8Array.slice(
        secretbox.nonceLength,
        encryptedMessage.length
    );    
    const decrypted = secretbox.open(message, nonce, keyUint8Array);
    const base64DecryptedMessage = encodeUTF8(decrypted);
    return base64DecryptedMessage;
}

export function getModulusFromString(s, b) {
    let data =[];
    for (var i = 0; i < s.length; i++){  
        data.push(s.charCodeAt(i));
    }
    return BigIntModulus(data, b);
}
export function BigIntModulus(a, b) {
    // If input is null, let's just return 0
    if (a == null) return 0;
    let m = 0;
    // Start with modding the most significant byte, then repeatedly shift
    // left. This way our value never gets larger than an int
    for (var i = 0; i < a.length; i++) {
        m <<= 8;
        m += (a[i] & 0xFF);
        m %= b;
    }
    return m;
}